

const PorfileCard = ({ profileDetails }) => {

    return (
      <>
        {" "}
        <div className="profile-card">
          <div className="profile-content">
            <div className="profile-avatar">
              <img
                src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=160&h=160&fit=crop&crop=face"
                alt="John Smith"
              />
            </div>

            <div className="profile-info">
              <h3>{profileDetails.NAME}</h3>
              <p>{profileDetails.EMAIL}</p>
              <p>{profileDetails["_CLASS_"]["NAME"]}</p>
              <p>{profileDetails["_SECTION_"]["NAME"]}</p>
            </div>
          </div>

          {/* Attendance Widget */}
          <div className="attendance-widget">
            {/* <div className="attendance-header">
              <span>Attendance</span>
              <span className="attendance-percentage">92%</span>
            </div> */}

            <div className="attendance-stats">
              <div className="attendance-stat present">
                <span className="stat-number">23</span>
                <span className="stat-label">Present</span>
              </div>

              <div className="attendance-stat absent">
                <span className="stat-number">2</span>
                <span className="stat-label">Absent</span>
              </div>

              <div className="attendance-stat total">
                <span className="stat-number">25</span>
                <span className="stat-label">Total</span>
              </div>
            </div>
          </div>
        </div>
        <style jsx>{`
          /* Profile Card */
          .profile-card {
            background: white;
            border-radius: 12px;
            padding: 1.75rem;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
            border: 1px solid #f1f5f9;
          }

          .profile-content {
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;
            margin-bottom: 1.75rem;
          }

          .profile-avatar {
            width: 100px;
            height: 100px;
            border-radius: 50%;
            margin-bottom: 1rem;
            overflow: hidden;
            border: 2px solid #f8fafc;
          }

          .profile-avatar img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }

          .profile-info h3 {
            font-size: 1.25rem;
            font-weight: 600;
            color: #1e293b;
            margin: 0 0 0.5rem 0;
          }

          .profile-info p {
            color: #64748b;
            margin: 0 0 0.25rem 0;
            font-size: 0.875rem;
            font-weight: 400;
          }

          .profile-info p:last-child {
            margin-bottom: 0;
          }

          /* Attendance Widget */
          .attendance-widget {
            width: 100%;
          }

          .attendance-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 1rem;
            padding-bottom: 0.75rem;
            border-bottom: 1px solid #f1f5f9;
          }

          .attendance-header span:first-child {
            font-size: 0.95rem;
            font-weight: 600;
            color: #374151;
          }

          .attendance-percentage {
            font-size: 1.125rem;
            font-weight: 600;
            color: #059669;
            background: #f9fafb;
            padding: 0.25rem 0.75rem;
            border-radius: 6px;
          }

          .attendance-stats {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 0.75rem;
          }

          .attendance-stat {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 1rem 0.5rem;
            border-radius: 8px;
            background: #fafbfc;
            border: 1px solid #f1f5f9;
            transition: all 0.15s ease;
          }

          .attendance-stat:hover {
            background: #f8fafc;
            border-color: #e2e8f0;
          }

          .stat-number {
            font-size: 1.25rem;
            font-weight: 600;
            margin-bottom: 0.25rem;
            color: #1e293b;
          }

          .attendance-stat.present .stat-number {
            color: #059669;
          }

          .attendance-stat.absent .stat-number {
            color: #dc2626;
          }

          .attendance-stat.total .stat-number {
            color: #3b82f6;
          }

          .stat-label {
            font-size: 0.75rem;
            font-weight: 500;
            color: #6b7280;
          }

          /* Responsive Design */
          @media (max-width: 768px) {
            .profile-card {
              padding: 1.5rem;
            }

            .profile-avatar {
              width: 85px;
              height: 85px;
            }

            .profile-info h3 {
              font-size: 1.125rem;
            }

            .attendance-stats {
              grid-template-columns: 1fr;
              gap: 0.5rem;
            }

            .attendance-stat {
              padding: 0.75rem;
              flex-direction: row;
              justify-content: space-between;
            }

            .attendance-percentage {
              font-size: 1rem;
              padding: 0.25rem 0.625rem;
            }
          }

          @media (max-width: 480px) {
            .attendance-header {
              flex-direction: column;
              gap: 0.75rem;
              text-align: center;
            }

            .profile-info p {
              font-size: 0.8rem;
            }

            .attendance-stat {
              padding: 0.625rem;
            }
          }
        `}</style>
      </>
    );
}

export default PorfileCard;